import { render, staticRenderFns } from "./justTwo.vue?vue&type=template&id=dfe60476&scoped=true&"
import script from "./justTwo.vue?vue&type=script&lang=js&"
export * from "./justTwo.vue?vue&type=script&lang=js&"
import style0 from "./justTwo.vue?vue&type=style&index=0&id=dfe60476&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe60476",
  null
  
)

export default component.exports